module.exports = __webpack_public_path__ + "img/depression.a3d36711.png";